<template>
  <div class="wechat-callback-bridge">
    <div class="title">微信授权成功</div>
    <div class="desc">正在返回登录页，请稍候...</div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const params = new URLSearchParams(window.location.search)

function buildPayload() {
  return {
    source: 'wechat-login-callback',
    code: params.get('code') || '',
    state: params.get('state') || '',
    error: params.get('error') || '',
    error_description: params.get('error_description') || ''
  }
}

function buildLoginHashUrl(payload) {
  const redirectPath = sessionStorage.getItem('wechat_login_redirect') || '/'
  const url = new URL(window.location.origin + window.location.pathname)

  const query = new URLSearchParams()
  if (payload.code) query.set('wechat_code', payload.code)
  if (payload.state) query.set('state', payload.state)
  if (payload.error) query.set('error', payload.error)
  if (payload.error_description) query.set('error_description', payload.error_description)
  if (redirectPath) query.set('redirect', redirectPath)

  url.hash = `/login${query.toString() ? `?${query.toString()}` : ''}`
  return url.toString()
}

onMounted(() => {
  const payload = buildPayload()

  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(payload, window.location.origin)
      return
    }
  } catch (error) {}

  window.location.replace(buildLoginHashUrl(payload))
})
</script>

<style lang="scss" scoped>
.wechat-callback-bridge {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
  color: #333;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
}

.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
}

.desc {
  font-size: 14px;
  color: #666;
}
</style>
